import React, { useRef, VFC } from 'react';

import { get } from 'lodash';

import ArticleBlock from '/components/ArticleBlock';
import { TableColumn } from '/components/BlockColumns';
import { BlockProps, ColumnContainerJson } from '/types';

const BlockTable: VFC<BlockProps> = ({
  animationEnabled,
  animationStep,
  setAnimationComplete,
  blockContent,
  blockBackgroundType,
  ...props
}) => {
  const tableRef = useRef<HTMLTableElement>(null);
  const columnData = get(blockContent, 'columns.list', []);
  setAnimationComplete(animationStep >= 1);

  return (
    <ArticleBlock
      {...props}
      blockContent={blockContent}
      blockBackgroundType={blockBackgroundType}
      hideFooter={animationEnabled && !animationStep}
      offset={2}
      titleCentered
      tableDownloadRef={tableRef}
      columns={columnData.map((column: ColumnContainerJson) => (
        <>
          {!column.hidden && column.name === 'table' && (
            <TableColumn
              elements={column.elements}
              background={blockBackgroundType}
              hide={animationEnabled && !animationStep}
              ref={tableRef}
            />
          )}
        </>
      ))}
    />
  );
};

BlockTable.displayName = 'BlockTable';
export default BlockTable;
